<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer.vue";
export default {
  components: {
    Header,
    Footer
  },
  mounted() {
  },
  methods: {

  }
}
</script>
<style lang="less">

</style>
